import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40047552&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style1 from "./index.vue?vue&type=style&index=1&id=40047552&scoped=true&lang=css&"
import style2 from "./index.vue?vue&type=style&index=2&id=40047552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40047552",
  null
  
)

export default component.exports